angular.module('dpw.components')
/**
 * @ngdoc directive
 * @name dpwAppGalleryTile
 * @restrict EA
 * @param {expression} app
 * @param {function} onClick - Post Link Function. Executed after the event is prevented.
 * @param {expression} appLogo
 * @description Tile Component for Dynamic App Gallery apps.
 * @example
 * <dpw-app-gallery-tile app="ctrl.appProfile" app-logo="ctrl.logoUtil.getLogo()"
 *                       on-click="ctrl.onTileClick(ctrl.appProfile)">
 * </dpw-app-gallery-tile>
 */
    .directive('dpwAppGalleryTile', [function () {
        return {
            restrict: 'EA',
            scope: {
                app: '=',
                linkBase: '<?',
                postClick: '&?onClick',
                appLogo: '='
            },
            templateUrl: 'dpw-app-gallery-tile.html',
            bindToController: true,
            controllerAs: 'ctrl',
            controller: ['helpers', function (helpers) {
                var self = this;
                var hasPostClickHandler = _.isFunction(self.postClick);

                self.getLink = function () {
                    var linkBase = self.linkBase ? self.linkBase : '/app-gallery.html';
                    var link = linkBase + '/app/' + self.app.id;

                    return hasPostClickHandler ? null : link;
                };
                self.click = function ($event) {
                    if (hasPostClickHandler) {
                        $event.preventDefault();
                        self.postClick();
                    }
                };
                self.appLogo = getLogo(self.appLogo);
                self.isLogoEmpty = function () {
                    var appLogo = self.appLogo || {};
                    return _.isUndefined(appLogo.file) && !self.isValidLogoUrl();
                };
                self.isValidLogoUrl = function () {
                    return !helpers.isPlaceHolderUrl(self.appLogo) && !_.isUndefined(self.appLogo.url);
                };
                self.onMouseEnter = function () {
                    self.isActive = true;
                };

                self.onMouseLeave = function () {
                    self.isActive = false;
                };

                function getLogo(appLogo) {
                    appLogo = _.isFunction(appLogo) ? appLogo() : appLogo;

                    return _.isString(appLogo) ? {
                        url: appLogo
                    } : appLogo;
                }
            }]
        };
    }]);